const PAYMENT_STATUSES = {
  pending: 0,
  cancelled: 1,
  approved: 2,
};

export default PAYMENT_STATUSES;
